export default "__VITE_ASSET__Dn41vyjZ__"